/**
 * Chester Pet Shop · pequeños ajustes de diseño
 * - La barra de envíos de la app trae emojis de camión/carrito en su texto: se cambian por patitas.
 */
(function () {
  var BAR = '.essential_free_shipping_bar_wrapper';
  var ICONS = /(\u{1F69A}|\u{1F6D2}|\u{1F6CD}️?)/gu;
  var PAW = '\u{1F43E}';

  function swap(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (ICONS.test(node.nodeValue)) {
        ICONS.lastIndex = 0;
        node.nodeValue = node.nodeValue.replace(ICONS, PAW);
      }
      ICONS.lastIndex = 0;
    }
  }

  function run() {
    document.querySelectorAll(BAR).forEach(swap);
  }

  run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
